import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class Notifications {
  private _newNotification = new Subject()
  newNotificationObservable = this._newNotification.asObservable()

  private _isModalOpen = new Subject<boolean>()
  isModalOpenObservable = this._isModalOpen.asObservable()

  private _showNotifications = new Subject<boolean>()
  showNotificationsObservable = this._showNotifications.asObservable()

  NewNotification(){
    this._newNotification.next()
  }

  IsModalOpen(show: boolean){
    this._isModalOpen.next(show)
  }

  ShowNotifications(show: boolean){
    this._showNotifications.next(show)
  }

}
